import { changeRole, selectRoleMembersOperation } from "fe2/Actions/ActionClanProfile";
import { hideDialog } from "fe2/Actions/ActionDialog";
import { connect } from "react-redux";
import { ChangeRoleOperationDialog } from "UIKit";

const mapStateToProps = state => {
  return {
    currentAccountRoleName: state.currentAccount.roleName,
    members: state.members.clans[state.currentAccount.clanId].members,
    selectedIds: state.membersOperation.selectedIds,
    selectedRole: state.membersOperation.selectedRole
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCloseClick: () => {
      dispatch(hideDialog());
    },
    onChangeClick: () => {
      return dispatch(changeRole(ownProps.memberToChangeId)).then(() => {
        dispatch(hideDialog());
      });
    },
    onRoleSelect: newRole => {
      dispatch(selectRoleMembersOperation(newRole));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRoleOperationDialog);